export default __webpack_public_path__ + "static/media/screenShots_poland-3.ad62f307.jpg";